var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("./../../assets/undering .png"),"alt":""}}),_c('p',{staticClass:"txt"},[_vm._t("title")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }